import { Routes } from "@angular/router";
import { AuthGuard } from "src/app/core/guards/auth.guard";

export const FeaturedCollectionRoutes: Routes = [
  {
    path: "featured-collections",
    loadComponent: () =>
      import("./featured-collection/featured-collection.component").then(
        (m) => m.FeaturedCollectionComponent,
      ),
    canActivate: [AuthGuard],
    children: [
      {
        path: "",
        loadComponent: () =>
          import("./featured-collection-list/featured-collection-list.component").then(
            (m) => m.FeaturedCollectionListComponent,
          ),
      },
      {
        path: "add",
        loadComponent: () =>
          import("./featured-collection-form/featured-collection-form.component").then(
            (m) => m.FeaturedCollectionFormComponent,
          ),
      },
      {
        path: "view/:id",
        loadComponent: () =>
          import("./featured-collection-form/featured-collection-form.component").then(
            (m) => m.FeaturedCollectionFormComponent,
          ),
      },
    ],
  },
];
